import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/logos/Anathameenakshi_no_bg.png"
export const LoadingScreen = ({ onLoadingComplete }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);

      setTimeout(() => {
        onLoadingComplete?.();
      }, 900);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <AnimatePresence>
      {loading && (
        <div className="fixed inset-0 z-[9999] flex overflow-hidden">

          {/* LEFT PANEL */}
          <motion.div
            initial={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="absolute left-0 top-0 w-1/2 h-full bg-obsidian flex items-center justify-end pr-3"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="w-48 h-48  flex items-center justify-center ">
                <img src={logo} alt="AnanthaMeenakshi Architect's logo"  />
              </div>
            </motion.div>
          </motion.div>

          {/* RIGHT PANEL */}
          <motion.div
            initial={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="absolute right-0 top-0 w-1/2 h-full bg-obsidian flex items-center justify-start pl-3"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="flex flex-col">
                <div className="flex items-center  hidden sm:block ">
                  <span className="text-gold text-2xl sm:text-s font-semibold ">
                    AnanthaMeenakshi
                  </span>
                  <span className="text-white text-2xl font-semibold ml-2">
                    Groups
                  </span>
                </div>

                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: "100%" }}
                  transition={{ duration: 0.9, delay: 0.6 }}
                  className="h-[2px] bg-gold mt-2"
                />
              </div>
            </motion.div>
          </motion.div>

          {/* CENTER LINE */}
          <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="absolute left-1/2 top-0 h-full w-[1px] bg-gold/20 -translate-x-1/2"
          />

          {/* LOADING TEXT */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.8 }}
            className="absolute bottom-20 left-1/2 -translate-x-1/2"
          >
            <div className="flex items-center gap-3">

              <motion.div
                animate={{ rotate: 360 }}
                transition={{
                  duration: 1.2,
                  repeat: Infinity,
                  ease: "linear",
                }}
                className="w-4 h-4 border-2 border-gold border-t-transparent rounded-full"
              />

              <span className="text-gray-400 text-sm tracking-wider uppercase">
                Loading Excellence
              </span>
            </div>
          </motion.div>

        </div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;